import { getBrandConfig } from "@/config/brand";

const setMetaContent = (selector: string, value: string) => {
  const node = document.head.querySelector<HTMLMetaElement>(selector);
  if (node) {
    node.content = value;
  }
};

const setLinkHref = (selector: string, value: string) => {
  const node = document.head.querySelector<HTMLLinkElement>(selector);
  if (node) {
    node.href = value;
  }
};

export const applyBrandToDocument = () => {
  if (typeof document === "undefined") {
    return;
  }

  const brand = getBrandConfig();
  const title = [brand.brandName, brand.tagline].filter(Boolean).join(" - ");

  if (title) {
    document.title = title;
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[name="twitter:title"]', title);
  }

  setMetaContent('meta[name="description"]', brand.metaDescription);
  setMetaContent('meta[name="author"]', brand.metaAuthor);
  setMetaContent('meta[property="og:description"]', brand.metaDescription);
  setMetaContent('meta[property="og:image"]', brand.paths.ogImage);
  setMetaContent('meta[name="twitter:site"]', brand.twitterSite);
  setMetaContent('meta[name="twitter:image"]', brand.paths.ogImage);
  setLinkHref('link[rel="icon"]', brand.paths.favicon);
};
